module.exports = __webpack_public_path__ + "static/media/consult.c4a0bcf2.png";